export const environment = {
  production: true,
  buildId: '2696239642218531',
  configFile: 'config.json',
};
